import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@flexisaf/flexibull2';
import Theme from 'utils/theme';
import {
  MinimizedExportCard,
  MinimizedCardHeader,
  MinimizedCardTitle,
  MinimizedCardSubtitle,
  HeaderIconButton,
  ProgressTrack,
  ProgressFill,
} from './styles';

const ExportMinimizedCard = ({
  progress = 0,
  complete = false,
  error = null,
  showProgress = true,
  title,
  subtitle,
  onExpand,
  onDismiss,
}) => {
  const clampedProgress = Math.max(0, Math.min(100, progress || 0));

  let statusText = title;
  if (!statusText) {
    statusText = `Generating export… ${clampedProgress}%`;
    if (error) statusText = 'Export failed';
    else if (complete || clampedProgress >= 100) statusText = 'Export complete';
  }

  const detailText =
    subtitle ||
    (error ? error : 'Your file will download automatically when ready.');

  return (
    <MinimizedExportCard role="status" aria-live="polite">
      <MinimizedCardHeader>
        <div>
          <MinimizedCardTitle>{statusText}</MinimizedCardTitle>
          <MinimizedCardSubtitle>{detailText}</MinimizedCardSubtitle>
        </div>
        <div style={{ display: 'flex', gap: 6 }}>
          <HeaderIconButton
            type="button"
            title="Expand export"
            aria-label="Expand export"
            onClick={onExpand}
          >
            <i className="saf-resize-full" />
          </HeaderIconButton>
          {(complete || error || !showProgress) && (
            <HeaderIconButton
              type="button"
              title="Dismiss"
              aria-label="Dismiss export card"
              onClick={onDismiss}
            >
              <i className="saf-cancel" />
            </HeaderIconButton>
          )}
        </div>
      </MinimizedCardHeader>
      {showProgress && (
        <>
          <ProgressTrack rounded>
            <ProgressFill
              value={error ? 100 : clampedProgress}
              error={Boolean(error)}
            />
          </ProgressTrack>
          <Text
            block
            size="12px"
            color={error ? Theme.PrimaryRed : Theme.PrimaryGrey}
            style={{ marginTop: 8 }}
          >
            {error ? 'Tap expand for details' : `${clampedProgress}% complete`}
          </Text>
        </>
      )}
    </MinimizedExportCard>
  );
};

ExportMinimizedCard.propTypes = {
  progress: PropTypes.number,
  complete: PropTypes.bool,
  error: PropTypes.string,
  showProgress: PropTypes.bool,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onExpand: PropTypes.func,
  onDismiss: PropTypes.func,
};

ExportMinimizedCard.defaultProps = {
  showProgress: true,
};

export default ExportMinimizedCard;
